/** Bill shipment statuses - phrases in Russian from 1C ERP database */
export enum BillShipmentStatusEnum {
  /** Bill not shipped (default value) */
  NOT_SHIPPED = 'NOT_SHIPPED',
  /** Bill fully shipped */
  SHIPPED = 'SHIPPED',
  /** Bill partially shipped */
  PARTIALLY_SHIPPED = 'PARTIALLY_SHIPPED',
}
